import { useEffect, useState } from "react";

import type { MeResponse } from "../api/types";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

export function AppShell({
  me,
  pageTitle,
  path,
  onLogout,
  children
}: {
  me: MeResponse;
  pageTitle: string;
  path: string;
  onLogout: () => Promise<void>;
  children: React.ReactNode;
}) {
  // Narrow viewports turn the sidebar into a hamburger-toggled drawer; the
  // toggle lives in the top bar and navigation closes it.
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    setNavOpen(false);
  }, [path]);

  return (
    <div className="app-shell">
      <Sidebar me={me} path={path} open={navOpen} onNavigate={() => setNavOpen(false)} />
      {navOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Close navigation"
          onClick={() => setNavOpen(false)}
        />
      )}
      <div className="app-shell__main">
        <TopBar
          me={me}
          pageTitle={pageTitle}
          onLogout={onLogout}
          onToggleNav={() => setNavOpen((open) => !open)}
        />
        <main className="app-shell__content">{children}</main>
      </div>
    </div>
  );
}
